import { FilterOptionsState } from '@mui/material';
import AutoComplete, { createFilterOptions } from '@mui/material/Autocomplete';
import { HTMLAttributes, SyntheticEvent, useState } from 'react';
import {
  ComboBoxContainer,
  AddButton,
  StyledAutoComplete,
  ListItem,
  AutoCompleteInput
} from './modifiers-auto-complete.styles';
import { Modifier } from '../../../types';
import { MODIFIERS_LOW, modifierTextToShow } from './modifiers-panel';
import { ComboBoxProps } from './panel-types';

interface ModifierAutoCompleteProps extends ComboBoxProps {
  values: Modifier[];
}

const EXAMPLE_MODIFIER: Modifier = {
  id: '',
  name: '',
  displayName: '',
  type: '',
  singleSelection: false,
  selectionRequired: false,
  minSelections: 0,
  maxSelections: 0,
  options: [],
  defaultOption: '',
  dateCreated: new Date(),
  dateUpdated: new Date()
};

const filter = createFilterOptions<Modifier>({stringify: (option) => modifierTextToShow(option)});

export function ModifiersAutocomplete(props: ModifierAutoCompleteProps) {
  const [selectedValue, setSelectedValue] = useState<Modifier | null>(null);
  const [modifierChosen, setModifierChosen] = useState<boolean>(false);

  function handleChange(event: SyntheticEvent, newValue: string | Modifier | null) {
    if (typeof newValue === 'string') {
      setSelectedValue({
        ...EXAMPLE_MODIFIER,
        type: newValue
      });
      setModifierChosen(false);
    } else {
      setSelectedValue(newValue);
      setModifierChosen(true);
    }
  }

  function filterModifiers(options: Modifier[], params: FilterOptionsState<Modifier>) {
    return filter(options, params);
  }

  function getModifierLabel(option: Modifier | string) {
    if (typeof option === 'string') {
      return option;
    }
    return modifierTextToShow(option);
  }

  function renderModifier(props: HTMLAttributes<HTMLLIElement>, option: Modifier): JSX.Element {
    return (
      <li {...props} id={`${option.id}-combo-box-item`} style={ListItem}>
        {modifierTextToShow(option)}
      </li>
    );
  }

  function clickHandler() {
    if (props.valueAddedHandler && modifierChosen && (selectedValue as Modifier)) {
      props.valueAddedHandler(modifierTextToShow(selectedValue as Modifier));
      setSelectedValue(null);
    }
  }

  return (
    <ComboBoxContainer id={`${MODIFIERS_LOW}-combo-box-container`}>
      <AutoComplete
        id={`${MODIFIERS_LOW}-select`}
        size='small'
        value={selectedValue}
        onChange={handleChange}
        filterOptions={filterModifiers}
        selectOnFocus
        handleHomeEndKeys
        options={props.values}
        getOptionLabel={getModifierLabel}
        clearOnBlur
        renderOption={renderModifier}
        renderInput={(params) => (
          <AutoCompleteInput {...params} placeholder={`Add ${MODIFIERS_LOW}`} />
        )}
        sx={StyledAutoComplete}
      />
      <AddButton id={`${MODIFIERS_LOW}-add-button`} onClick={clickHandler}>
        Add
      </AddButton>
    </ComboBoxContainer>
  );
}
